'use client';
'use client';

import * as React from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { TooltipProvider } from '@/components/ui/tooltip';

export function ThemeProvider({ children }) {
  // Prefer stored theme; if none set, default to dark on react.truu.com
  let defaultTheme = 'system';
  try {
    if (typeof window !== 'undefined') {
      const stored = window.localStorage?.getItem('nextjs-theme');
      const host = window.location?.hostname || '';
      defaultTheme = stored || (host === 'react.truu.com' ? 'dark' : 'system');
    }
  } catch (_) {
    // no-op: fallback to system
  }

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme={defaultTheme}
      storageKey="nextjs-theme"
      enableSystem
      disableTransitionOnChange
      enableColorScheme
    >
      <TooltipProvider delayDuration={0}>{children}</TooltipProvider>
    </NextThemesProvider>
  );
}
